import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { Images } from "@/assets/images.tsx";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

import { version } from "../../../package.json";

export const AboutSteto: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Card id="about-steto-card" className={styles.container}>
      <CardHeader id="about-title" title={t("pages.account.about.title")} />
      <CardContent className={styles.body}>
        <div className={styles.content}>
          <Typography id="about-description" variant="body">
            {t("pages.account.about.description")}
          </Typography>
          <div className={styles.imagesRow}>
            <div className={styles.stetoInfo}>
              <Icons.logoBlueFull id="about-logo" className={styles.logo} />
              <Typography id="version" variant="body">
                {version}
              </Typography>
              <Images.stetoInfo id="steto-info" className={styles.image} alt="steto-info" />
            </div>
            <div className={styles.stetoCE}>
              <Typography id="about-name" variant="body">
                {t("pages.account.about.name")}
              </Typography>
              <Typography id="about-address" variant="body">
                {t("pages.account.about.address")}
              </Typography>
              <Typography id="about-postCode" variant="body">
                {t("pages.account.about.postCode")}
              </Typography>
              <Typography id="about-rcs" variant="body">
                {t("pages.account.about.rcs")}
              </Typography>
              <Typography id="about-class" variant="body">
                {t("pages.account.about.class")}
              </Typography>
              <Icons.ce id="about-ce-logo" className={styles.logo} />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css``,
  body: css`
    align-items: center;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    width: 100%;
  `,
  imagesRow: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: ${theme.spacing(8)} 0;
    gap: ${theme.spacing(16)};
    flex-wrap: wrap;
  `,
  stetoCE: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  stetoInfo: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
  logo: css`
    width: fit-content;
    height: ${FontSizes.h4};
    margin-bottom: ${theme.spacing(4)};
  `,
  image: css`
    width: ${IMAGE_WIDTH_PX}px;
  `,
  icon: css`
    height: 3em;
    margin-top: ${theme.spacing(8)};
  `,
});

const IMAGE_WIDTH_PX = 300;
